import { Box } from '@mui/system';
import React from 'react';

// Component
import FareInDayNewYear from './FareInDayNewYear';

function Section8(props: any) {
  const {
    daysInNewYears, handleSelectTrip, isDesktop,
  } = props;

  return (
    <Box sx={{
      background: '#FFFFFF',
      boxShadow: '0px 2px 10px rgba(7, 65, 57, 0.15)',
      borderRadius: '12px',
      overflow: 'hidden',
    }}
    >
      <FareInDayNewYear
        isDesktop={isDesktop}
        days={daysInNewYears}
        onSelectTrip={handleSelectTrip}
      />
    </Box>
  );
}

export default React.memo(Section8);
